<div>
  <div class="">
    <div class="container">
      <div class="row my-4">
        <div class="col-md-12 px-4">
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header class="purchase-header">
              <mat-panel-title><h5 class="mb-0">Your Property Equity</h5></mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row">
              <div class="col-lg-12 table-responsive">
                <table class="w-100 myh_val">
                  <tr>
                    <td class="tab-border myH_proprate mb-4">
                      <label
                        >Purchase Price
                        <button
                          class="myHedit_btn"
                          style="margin-left: 8px"
                          [ngbPopover]="purchaseValueContent"
                          #purchaseValuePopover="ngbPopover"
                          [popoverTitle]="purchaseValueTitle"
                          placement="bottom"
                          [autoClose]="false"
                        >
                          &#9998;
                        </button></label
                      >
                      <h4>{{ purchaseValue | currency: 'USD':'symbol':'0.0-0' | IsValueExist }}</h4>
                      <p *ngIf="soldDate">Sold: {{ soldDate | date: 'mediumDate' | IsValueExist }}</p>
                      <p *ngIf="!soldDate">&nbsp;</p>
                      <ng-template #purchaseValueContent>
                        <form [formGroup]="spendForecastForm">
                          <mat-form-field>
                            <input
                              type="number"
                              min="0"
                              class="text-center purchase-input"
                              floatLabel="never"
                              matInput
                              formControlName="customPurchaseValue"
                              autocomplete="off"
                              (keydown)="allowOnlyNumbers($event)"
                            />
                          </mat-form-field>
                          <button mat-icon-button aria-label="Cancel" matTooltip="Cancel">
                            <i
                              class="material-icons"
                              (click)="revertValue('customPurchaseValue')"
                              style="font-size: 20px; color: #60697a"
                            >
                              restart_alt
                            </i>
                          </button>
                          <button mat-icon-button aria-label="Ok" matTooltip="Ok">
                            <i
                              class="material-icons"
                              (click)="saveValue('customPurchaseValue')"
                              style="font-size: 20px; color: #4caf50"
                            >
                              done
                            </i>
                          </button>
                        </form>
                      </ng-template>
                      <ng-template #purchaseValueTitle
                        >Edit Purchase Price
                        <button mat-icon-button aria-label="Ok" matTooltip="close">
                          <i
                            class="material-icons"
                            style="font-size: 20px; color: #bdbdd0"
                            (click)="purchaseValuePopover.close()"
                          >
                            close
                          </i>
                        </button></ng-template
                      >
                    </td>
                    <td class="Appreciation">
                      <!-- <h4 class="mb-1" *ngIf="isNegativeOrder(potentialMonthlyRent - totalPaymentMonthly)">--</h4>
              <h4 class="mb-1" *ngIf="!isNegativeOrder(potentialMonthlyRent - totalPaymentMonthly)">
                ${{ potentialMonthlyRent - totalPaymentMonthly | toNumber | number: '1.0-0' }}
              </h4> -->
                      <h4 style="margin-bottom: 5px" *ngIf="!isNegativeOrder(appreciateRatio)">
                        <img class="pr-1" src="../../assets/images/increase.png" />{{
                          appreciateRatio ? appreciateRatio.toFixed() : '0'
                        }}
                        %
                      </h4>
                      <h4
                        style="margin-bottom: 5px; color: #c41414 !important"
                        *ngIf="isNegativeOrder(appreciateRatio)"
                      >
                        <img class="pr-1" src="../../assets/images/down.png" />{{
                          appreciateRatio ? appreciateRatio.toFixed() : '0'
                        }}
                        %
                      </h4>
                      <p>Appreciation</p>
                    </td>
                    <td class="tab-border">
                      <label>PropMix Estimate</label>
                      <ng-container *ngIf="propmixValue != 0; else zeroPropmixValue">
                        <h4>{{ propmixValue | currency: 'USD':'symbol':'0.0-0' | IsValueExist }}</h4>
                      </ng-container>
                      <ng-template #zeroPropmixValue>
                        <h4>--</h4>
                      </ng-template>
                      <p>&nbsp;</p>
                    </td>
                    <td class="sign">
                      <h4>-</h4>
                    </td>
                    <td class="tab-border">
                      <label>Loan Balance (Est.)</label>
                      <ng-container *ngIf="loanBalance != 0; else zeroBalance">
                        <h4>{{ loanBalance | currency: 'USD':'symbol':'0.0-0' }}</h4>
                      </ng-container>
                      <ng-template #zeroBalance>
                        <h4>--</h4>
                      </ng-template>

                      <p class="a-analyze" (click)="onSectionScrolled($event)">Save On Mortgages</p>
                    </td>
                    <td class="sign">
                      <h4>=</h4>
                    </td>
                    <td class="cal-balance">
                      <label>Your Net Equity</label>
                      <h4>{{ netEquity | currency: 'USD':'symbol':'0.0-0' | IsValueExist }}</h4>
                      <p class="total-analyze" (click)="equitySectionScrolled($event)">Unlock your Equity</p>
                    </td>
                    <td colspan="2">&nbsp;</td>
                  </tr>
                </table>
              </div>
            </div>
          </mat-expansion-panel>
        </div>
      </div>
    </div>

    <!-- <div class="dash_base"> -->
    <div class="container">
      <div class="row my-4">
        <div class="col-lg-12 px-4">
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title><h5 class="mb-0">Your Monthly Costs</h5></mat-panel-title>
            </mat-expansion-panel-header>
            <app-property-monthly-cost></app-property-monthly-cost>
          </mat-expansion-panel>
        </div>
      </div>
      <div class="row my-4">
        <div class="col-lg-12 px-4" #mortgageSectionToScroll>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title
                ><h5 class="mb-0">Current Mortgage Details</h5>
                <button mat-flat-button mat-stroked-button (click)="$event.stopPropagation(); openMortgagePopup()">
                  Add Mortgage
                </button></mat-panel-title
              >
            </mat-expansion-panel-header>
            <app-mortgage-group
              *ngIf="mortgageArray?.length > 0"
              [mortgageList]="mortgageArray?.length > 0 ? mortgageArray : []"
              >></app-mortgage-group
            >
          </mat-expansion-panel>
        </div>
      </div>

      <div class="row my-4" *ngIf="mortgageArray?.length != 0">
        <div class="col-lg-12 px-4">
          <mat-expansion-panel [expanded]="true" class="financing">
            <mat-expansion-panel-header>
              <mat-panel-title><h5 class="mb-0">See how you can save on your mortgage</h5></mat-panel-title>
            </mat-expansion-panel-header>
            <mat-tab-group class="savings-tab">
              <mat-tab>
                <ng-template mat-tab-label> Pay Extra Every Month</ng-template>
                <div mat-dialog-content>
                  <app-extra-payment class="mortgage-tab" [mortgageList]="mortgageArray"></app-extra-payment>
                </div>
              </mat-tab>
              <mat-tab>
                <ng-template mat-tab-label> Refinance </ng-template>
                <div mat-dialog-content>
                  <app-refinance class="mortgage-tab" [mortgageList]="mortgageArray"></app-refinance>
                </div>
              </mat-tab>
            </mat-tab-group>
          </mat-expansion-panel>
        </div>
      </div>

      <div class="row my-4 mb-5">
        <div class="col-lg-12 px-4" #equitySectionToScroll>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title><h5 class="mb-0">What can you do with your home equity?</h5></mat-panel-title>
            </mat-expansion-panel-header>
            <app-spend-forecast
              [propertyValue]="propmixValue || currentValue"
              [loanBalance]="loanBalance"
              [source]="source"
            >
            </app-spend-forecast>
          </mat-expansion-panel>
        </div>
      </div>
      <br />
      <!-- <div class="row">
        <div class="col-xl-3 col-lg-4 col-md-5 col-sm-12 px-1 pr-md-0 pl-md-3 mb-4">
          <app-property-overview
            [address]="address"
            [currentValue]="currentValue"
            [propmixValue]="propmixValue"
            [loanBalance]="loanBalance"
            [netEquity]="netEquity"
            [appreciateRatio]="appreciateRatio"
            [purchaseValue]="purchaseValue"
            (currentValueEvent)="currentValueEdited($event)"
            (propmixValueEvent)="propmixValueEdited($event)"
            (purchaseValueEvent)="purchaseValueEdited($event)"
          >
          </app-property-overview>
        </div>
        <div class="col-xl-9 col-lg-8 col-md-7 col-sm-12 mb-4 px-1 px-md-3">
          <mat-card>
            <app-mortgage-group [mortgageList]="mortgageArray"></app-mortgage-group>
          </mat-card>
        </div>
      </div> -->
      <!-- <div class="footer_menu" *ngIf="(this.myHomeState.myHomeList$ | async)?.length && address">
        <div class="row px-2">
          <div class="col-lg-9 col-md-9 col-7 myH_name px-2">
            <h5 [propertyAddress]="address.fullAddress">{{ address.streetAddress }}</h5>
            <span [propertyAddress]="address.fullAddress"
              >{{ address.city }}, {{ address.state }},{{ address.zip }}</span
            >
          </div>
          <div class="col-lg-3 col-md-3 col-5 px-2">
            <button class="float-right mt-md-2 mt-1" mat-flat-button color="primary" (click)="updateHome()">
              <mat-icon inline="true" class="mr-md-2 mr-0">save</mat-icon
              ><span class="d-none d-md-inline-block">Save</span>
            </button>
            <button
              class="close float-right mt-1 d-block d-md-none mr-2"
              (click)="deleteProperty(address.id)"
              mat-flat-button
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div> -->
    </div>
    <ng-template #noMyHome>
      <div class="no-data-placeholder text-center py-4">
        <img src="assets/images/partnerholder.png" width="260px" />
        <h5 class="mb-4">Your home will be listed here</h5>
        <mat-spinner [diameter]="30" *ngIf="isLoading; else addNewHome"></mat-spinner>
        <ng-template #addNewHome>
          <h6 class="mb-3">You can start by adding a new home.</h6>
          <button mat-flat-button color="primary" (click)="openAppPropertyDialog(null)">Add a Property</button>
        </ng-template>
      </div>
    </ng-template>
  </div>
</div>
<div class="footer_menu d-block d-md-none" *ngIf="(this.myHomeState.myHomeList$ | async)?.length && address">
  <div class="row px-2">
    <div class="col-lg-9 col-md-9 col-8 myH_name px-2">
      <h5>{{ address.streetAddress }}</h5>
      <span>{{ address.city }}, {{ address.state }},{{ address.zip }}</span>
    </div>
    <div class="col-lg-3 col-md-3 col-4 px-2">
      <!-- <button class="float-right mt-md-2 mt-1" mat-flat-button color="primary" (click)="updateHome()">
        <mat-icon inline="true" class="mr-md-2 mr-0">save</mat-icon><span class="d-none d-md-inline-block">Save</span>
      </button> -->
      <button
        class="close float-right mt-1 d-block d-md-none mr-2"
        (click)="deleteProperty(address.id)"
        mat-flat-button
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>
</div>
<!-- <mat-sidenav-container *ngIf="spendForecastSheetActive">
  <mat-sidenav
    class="main row spend_forecast"
    #sidenav
    mode="over"
    position="end"
    [opened]="spendForecastSheetActive"
    disableClose
  >
    <div class="sliding-sheet-header">
      <button type="button" (click)="closeSpendForecastSheet()"><mat-icon>close</mat-icon></button>
    </div>

    <div class="slidesheetcontent">
      <app-spend-forecast [propertyValue]="propmixValue || currentValue" [loanBalance]="loanBalance">
      </app-spend-forecast>
    </div>
  </mat-sidenav>
</mat-sidenav-container> -->
